<template>
    <div class="main-partner mb-40px">
        <div class="container">
            <!-- <div class="page-title-content">
                <h2>{{ data?.pageTitle || 'Our Page' }}</h2>
                <ul>
                    <li style="list-style-type: none;">
                        <router-link to="/">Home</router-link>
                    </li>
                    <li>attributes</li>
                </ul>
            </div> -->


            <div class="row align-items-center m-0">
                <div class="col-lg-6 col-md-12 p-0">
                    <div class="banner-content inner-banner"><span class="sub-title">Future Together</span>
                        <h1 class="text-white">Let’s Build the Future Together</h1>
                        <p class="text-left text-white" style="margin: 0px;">Partner with Meander Software to unlock new revenue streams, deliver cutting-edge AI solutions, and create lasting value for your clients.</p>
                         <router-link to="/contact"><a href="#" class="default-btn partner-btn"> Become a Partner</a></router-link>
                    </div>
                </div>
                <div class="col-lg-6 col-md-12 p-0">
                    <div class="banner-image aos-init aos-animate" data-aos="fade-down" data-aos-duration="2000"><img
                            src="../../assets/images/Your-Partner.png" alt="image"></div>
                </div>
            </div>
        </div>
        <div class="divider" style="background-color: #f7f7ff;"></div>
         <div class="lines">
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
            <div class="line"></div>
        </div> 
         <div class="banner-shape1">
            <img src="../../assets/images/shape/shape9.png" alt="image">
        </div> 
    </div>
</template>


<style>
.main-partner {
    z-index: 1;
    position: relative;
    padding-bottom: 100px;
    padding-top: 120px;
    background-color: #101720;
}
.inner-banner {
text-align: left !important;

h1 {
    text-align: left;
    position: relative;
}
p {
    text-align: left;
          margin: 0px;
        padding-bottom: 20px;
}
}
.inner-banner span.sub-title {
    text-align: left;
}


.inner-banner h1.text-white::after {
    content: "";
    position: absolute;
    left: 250px;
    background-color: #272e36ab;
    width: 65px;
    height: 65px;
    border-radius: 100%;
    bottom: 0px;
    animation: movebounce 2s linear infinite;
}
</style>

<script>
export default {
    name: 'PageTitle2',
    props:{
        
        data: {
      type: [], // Set the prop type to be Any
      required: true,
    },
    },
    
    }
</script>